import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import InputSimple from '@r1-frontend/ui-react/components/inputSimple';
import { TickCircle } from '@r1-frontend/ui-react/components/svg/main';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const PromoWrapper = styled.div`
  width: 100%;
`;

export const FormLine = styled.div`
  width: 100%;
  justify-content: space-between;
  align-items: baseline;
  flex-direction: row;
  gap: 12px;
`;

export const StyledInputSimple = styled(InputSimple)`
  flex: 1;
  margin-bottom: 0;
`;

export const ResultLine = styled.div`
  width: 100%;
  justify-content: space-between;
  flex-direction: row;
  gap: 8px;
`;

export const Icon = styled(TickCircle)`
  & g{
    stroke: #15A250 !important;
  }
`;

export const Text = styled.div`
  flex: 1;
  ${FONTS.XS};
  & > span {
    display: contents;
    ${FONTS.H6};
  }
`;

export const StyledButton = styled(Button)`
  padding: 6px 0;
`;
